import * as actionType from "./actionTypes";
import { createReducer, updateObject } from "../../utils/reducerUtils";

/* State shape same as initial state
*/
const initialState = {
  summary: null,
  //Default to every order, so pending (unpaid / cancelled on Yoco) checkouts show too
  filters: {
    payment: "all",
    fulfilment: "all",
    search: "",
  },
  orders: [],
  total: 0,
  page: 1,
  pageSize: 25,
  order: null,
};

const setSummary = (state, action) => (
  updateObject(state, {
    summary: action.summary,
  })
);

const setFilters = (state, action) => (
  updateObject(state, {
    filters: updateObject(state.filters, action.filters),
  })
);

const setOrders = (state, action) => (
  updateObject(state, {
    orders: action.result.orders,
    total: action.result.total,
    page: action.result.page,
    pageSize: action.result.pageSize,
  })
);

const setOrder = (state, action) => (
  updateObject(state, {
    order: action.order,
  })
);

const reducer = createReducer(initialState, {
  [actionType.SET_SUMMARY]: setSummary,
  [actionType.SET_FILTERS]: setFilters,
  [actionType.SET_ORDERS]: setOrders,
  [actionType.SET_ORDER]: setOrder,
});

export default reducer;

// SELECTORS
export const getSummary = (state) => state.summary;
export const getFilters = (state) => state.filters;
export const getOrders = (state) => state.orders;
export const getPaging = (state) => ({ total: state.total, page: state.page, pageSize: state.pageSize });
export const getOrder = (state) => state.order;
